import API from '@/api'
import CropbarStore from './crop-bar.store'
import CroDropdownStore from './crop-dropdown.store'

export default {
  namespaced: true,
  modules: {
    'cropbar': CropbarStore,
    'dropdown': CroDropdownStore,
  },
  state: {

    selecting_base: false,

    data: {},

    base: {},
    variety: {},
    method: {},
    goal: {},

    crop_list: [],

    filters: {
      take: 10,
      page: 0,
      type: 'soil-grown',
    }
  },
  mutations: {
    reset(state) {
      state.variety = {};
      state.base = {};
      state.method = {};
      state.goal = {};

      state.data = {};
    },

    setVarietyFile(state, file) {
      state.variety.file = file;
    },

    removeVarietyFile(state, file) {
      delete state.variety.file;
    },

    setSelectingBaseMode(state, flag) {
      state.selecting_base = flag;
    },

    saveBase(state, data) {
      state.data = data;
      state.base = data;

      if(state.base.varieties && state.base.varieties[0]) {
        state.variety = state.base.varieties[0];
      } else {
        state.variety = {};
      }

      if (state.variety.methods && state.variety.methods[0]) {
        state.method = state.variety.methods[0];
      } else {
        state.method = {};
      }

      if (state.method.goals && state.method.goals[0]) {
        state.goal = state.method.goals[0];
      } else {
        state.goal = {};
      }
    },
    saveVariety(state, item) {
      state.variety = item;

      if (state.variety.methods && state.variety.methods[0]) {
        state.method = state.variety.methods[0];
      } else {
        state.method = {};
      }

      if (state.method.goals && state.method.goals[0]) {
        state.goal = state.method.goals[0];
      } else {
        state.goal = {};
      }
    },
    saveMethod(state, item) {
      state.method = item;

      if (state.method.goals && state.method.goals[0]) {
        state.goal = state.method.goals[0];
      } else {
        state.goal = {};
      }
    },
    saveGoal(state, item) {
      state.goal = item;
    },

    saveVarieties(state, items) {

      state.base.varieties = items.map(n => {
        if(n.id === state.variety.id) {
          n.methods = state.variety.methods;
          state.variety = n;
        }
        return n
      });
    },
    saveMethods(state, items) {
      state.variety.methods = items.map(n => {
        if(n.id === state.method.id) {
          n.goals = state.method.goals;
          state.method = n;
        }
        return n
      });
    },
    saveGoals(state, items) {
      state.method.goals = items.map(n => {
        if(n.id === state.goal.id) {
          n.stages = state.goal.stages;
          state.goal = n;
        }
        return n
      });
    },
    saveStages(state, items) {
      state.goal.stages = items;
    },
  },
  actions: {

    updateBaseCrop(context, id) {
      return API.crop.getBaseCrop(id).then(res => {
        context.commit('saveBase', res.data.data);
        return res;
      });
    },

    selectVariety(context, id) {
      return API.crop.getInfoByVariety(id).then(res => {
        context.commit('saveVariety', res.data.data);
        return res;
      });
    },

    selectMethod(context, id) {
      return API.crop.getInfoByMethod(id).then(res => {
        context.commit('saveMethod', res.data.data);
        return res;
      });
    },

    selectGoal(context, id) {
      // console.log(id);
      return API.crop.getInfoByGoal(id).then(res => {
        context.commit('saveGoal', res.data.data);
        return res;
      });
    },

    updateVarieties(context, id = 0) {
      id = id ? id : context.getters.base.id;
      return API.crop.getCropVarieties(id).then(res => {
        context.commit('saveVarieties', res.data.data);
        return res;
      });
    },

    updateMethods(context, id = 0) {
      id = id ? id : context.getters.variety.id;

      return API.crop.getCropGrowingMethods(id).then(res => {
        context.commit('saveMethods', res.data.data);
        return res;
      });
    },

    updateGoals(context, id = 0) {
      id = id ? id : context.getters.method.id;

      return API.crop.getYieldGoals(id).then(res => {
        context.commit('saveGoals', res.data.data);
        return res;
      });
    },

    updateStages(context, id = 0) {
      id = id ? id : context.getters.goal.id;

      return API.crop.getCropStages(id).then(res => {
        context.commit('saveStages', res.data.data);
        return res;
      });
    },
  },
  getters: {
    isSelectingBase(state) {
      return state.selecting_base;
    },

    base(state) {
      return state.base;
    },
    variety(state) {
      return state.variety;
    },
    method(state) {
      return state.method;
    },
    goal(state) {
      return state.goal;
    },


    goals(state) {
      let data = state.method.goals;

      data.sort((a,b) => (a.goal > b.goal) ? 1 : ((b.goal > a.goal) ? -1 : 0));

      return data;

    },
    varieties(state) {
      return state.base.varieties;
    },
    varietiesForSelector(state) {
      return state.base.varieties;
    },
    methods(state) {
      return state.variety.methods;
    },
    stages(state) {
      return state.goal.stages;
    },


    filters(state) {
      return state.filters;
    },
    cropList(state) {
      return state.crop_list;
    },
  }
};
